module.exports = __webpack_public_path__ + "img/Pound Icon - white.9a0fbc18.svg";